import React from 'react';

interface Props{
  x:number;
  y:number;
  colour:string;
  bold:boolean;
  italic:boolean;
  underline?:boolean;
  fontSize:number;
  onChange:(partial:{color?:string;bold?:boolean;italic?:boolean;underline?:boolean;fontSize?:number})=>void;
  onDelete:()=>void;
  onClose:()=>void;
}

const COLORS=['#000000','#1f2937','#ef4444','#3b82f6','#10b981'];

const TextBoxToolbar:React.FC<Props>=({x,y,colour,bold,italic,underline,fontSize,onChange,onDelete,onClose})=>{
 const [showPalette,setShowPalette]=React.useState(false);
 return (
  <div className="absolute z-50 bg-gray-900/90 text-white rounded-lg shadow-xl flex items-center gap-2 px-3 py-2" style={{left:x,top:y}} onMouseLeave={()=>setShowPalette(false)}>
    {/* colour */}
    <div className="relative">
      <button className="w-4 h-4 rounded-full border-2 border-white" style={{backgroundColor:colour}} onClick={()=>setShowPalette(p=>!p)}/>
      {showPalette && (
        <div className="absolute -left-4 top-6 bg-gray-800/95 p-2 rounded-md flex gap-1">
          {COLORS.map(c=>(<div key={c} className={`w-4 h-4 rounded-full border-2 ${c===colour?'border-blue-400':'border-transparent'} cursor-pointer`} style={{backgroundColor:c}} onClick={()=>{onChange({color:c}); setShowPalette(false);}}/>))}
        </div>
      )}
    </div>
    {/* font size */}
    <div className="flex items-center gap-1">
      <button className="text-xs px-1" onClick={()=>onChange({fontSize:fontSize-1})}>A-</button>
      <span className="text-xs w-5 text-center">{fontSize}</span>
      <button className="text-xs px-1" onClick={()=>onChange({fontSize:fontSize+1})}>A+</button>
    </div>
    <button className={`px-1 text-sm font-bold rounded ${bold?'bg-gray-700':''}`} onClick={()=>onChange({bold:!bold})}>B</button>
    <button className={`px-1 italic text-sm rounded ${italic?'bg-gray-700':''}`} onClick={()=>onChange({italic:!italic})}>I</button>
    <button className={`px-1 underline text-sm rounded ${underline?'bg-gray-700':''}`} onClick={()=>onChange({underline:!underline})}>U</button>
    <button className="px-1 ml-2 hover:bg-red-600 rounded" onClick={onDelete}>🗑</button>
    <button className="text-xs ml-1" onClick={onClose}>✕</button>
  </div>
 );
};

export default TextBoxToolbar; 